<script lang="ts">
  import RecentOrdersDatePicker from "@modern/components/retailer/reports/RecentOrdersDatePicker.svelte";
  import { debounce } from "@shared/svelte/utils";

  export let startDate;
  export let endDate;
  export let search;
  export let placeholder;
  export let refreshData;

  const runSearch = debounce(refreshData, 300);

</script>

<style>
  @media (max-width: 700px) {
    .reports-orders-search-bar {
      display: block;
      padding-bottom: 1rem;
    }
  }

</style>

<div class="grid-container margin-top--small">
  <div class="grid-row background-white">
    <div class="grid-col c12-12 c8-12--md vertical-align-middle">
      <div class="padding-top--smaller padding-bottom--smaller fizz-styles">
        <RecentOrdersDatePicker bind:startDate bind:endDate refreshState={refreshData} />
      </div>
    </div>
    <div class="grid-col c12-12 c4-12--md vertical-align-middle reports-orders-search-bar">
      <div class="media">
        <div class="media-fluid">
          <div class="input-wrapper full-width">
            <input
              type="text"
              class="input"
              bind:value={search}
              on:input={runSearch}
              {placeholder}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
